import React, { useState, useEffect, useRef } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";

export function PageUserMgmt({user}){
  var T=React.useContext(ThemeCtx).T;
  var _users=useState([]); var users=_users[0]; var setUsers=_users[1];
  var _pods=useState([]); var pods=_pods[0]; var setPods=_pods[1];
  var _sel=useState(null); var sel=_sel[0]; var setSel=_sel[1];
  var _showAdd=useState(false); var showAdd=_showAdd[0]; var setShowAdd=_showAdd[1];
  var _showReset=useState(null); var showReset=_showReset[0]; var setShowReset=_showReset[1];
  var _msg=useState({text:"",type:""}); var msg=_msg[0]; var setMsg=_msg[1];
  var _form=useState({name:"",username:"",email:"",password:"",role:"team",pod:""}); var form=_form[0]; var setForm=_form[1];
  var _newPw=useState(""); var newPw=_newPw[0]; var setNewPw=_newPw[1];
  var showMsg=function(text,type){setMsg({text,type});setTimeout(function(){setMsg({text:"",type:""});},4000);};
  var setF=function(k,v){setForm(function(p){var n=Object.assign({},p);n[k]=v;return n;});};
  var inputStyle={width:"100%",padding:"9px 10px",background:T.inset,border:"1px solid "+T.border,borderRadius:8,color:T.text,fontSize:13,outline:"none",boxSizing:"border-box"};
  var labelStyle={fontSize:11,color:T.text3,marginBottom:4,textTransform:"uppercase",letterSpacing:.5,display:"block"};
  useEffect(function(){
    api.get("/users").then(setUsers).catch(function(){});
    api.get("/pods").then(setPods).catch(function(){});
  },[]);
  var createUser=async function(){
    if(!form.name||!form.username||!form.password){showMsg("Name, username and password required","error");return;}
    if(form.password.length<8){showMsg("Password must be 8+ chars","error");return;}
    try{
      var u=await api.post("/users",form);
      setUsers(function(p){return p.concat([u]);});
      setShowAdd(false); setForm({name:"",username:"",email:"",password:"",role:"team",pod:""});
      showMsg("User created","success");
    }catch(e){showMsg(e.message,"error");}
  };
  var updateUser=async function(id,updates){
    try{
      var u=await api.patch("/users/"+id,updates);
      setUsers(function(p){return p.map(function(x){return x.id===id?Object.assign({},x,u):x;});});
      showMsg("Updated","success");
    }catch(e){showMsg(e.message,"error");}
  };
  var deleteUser=async function(id,name){
    if(!window.confirm("Delete user "+name+"? This cannot be undone.")) return;
    try{
      await api.delete("/users/"+id);
      setUsers(function(p){return p.filter(function(x){return x.id!==id;});});
      showMsg("Deleted","success");
    }catch(e){showMsg(e.message,"error");}
  };
  var resetPassword=async function(id){
    if(!newPw||newPw.length<8){showMsg("Min 8 chars","error");return;}
    try{
      await api.post("/users/"+id+"/reset-password",{new_password:newPw});
      setShowReset(null); setNewPw(""); showMsg("Password reset","success");
    }catch(e){showMsg(e.message,"error");}
  };
  var unlockUser=async function(id){
    try{
      await api.post("/users/"+id+"/unlock",{});
      setUsers(function(p){return p.map(function(x){return x.id===id?Object.assign({},x,{locked:false,login_attempts:0}):x;});});
      showMsg("Unlocked","success");
    }catch(e){showMsg(e.message,"error");}
  };
  var ROLES=["admin","lead","team","owner","agent"];
  var RC={admin:"#ef4444",lead:"#6366f1",team:"#3b82f6",owner:"#22c55e",agent:"#8b5cf6"};
  return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},
    msg.text&&React.createElement("div",{style:{background:msg.type==="success"?T.success+"22":T.danger+"22",border:"1px solid "+(msg.type==="success"?T.success:T.danger)+"44",borderRadius:8,padding:"10px 14px",fontSize:13,color:msg.type==="success"?T.success:T.danger}},msg.text),
    React.createElement("div",{style:{display:"flex",justifyContent:"space-between",alignItems:"center"}},
      React.createElement("div",{style:{fontSize:12,color:T.text3}},users.length+" users"),
      React.createElement("button",{onClick:function(){setShowAdd(true);},style:{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",cursor:"pointer",fontSize:13,fontWeight:600}},"+ New User")
    ),
    showAdd&&React.createElement(Modal,{title:"Create User",onClose:function(){setShowAdd(false);}},
      React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
        React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}},
          [["name","Full Name"],["username","Username"],["email","Email"],["password","Password"]].map(function(item){
            return React.createElement("div",{key:item[0]},
              React.createElement("label",{style:labelStyle},item[1]),
              React.createElement("input",{type:item[0]==="password"?"password":"text",value:form[item[0]],onChange:function(e){setF(item[0],e.target.value);},style:inputStyle})
            );
          })
        ),
        React.createElement("div",{style:{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}},
          React.createElement("div",null,React.createElement("label",{style:labelStyle},"Role"),
            React.createElement("select",{value:form.role,onChange:function(e){setF("role",e.target.value);},style:inputStyle},
              ROLES.map(function(r){return React.createElement("option",{key:r,value:r},r);})
            )
          ),
          React.createElement("div",null,React.createElement("label",{style:labelStyle},"Pod"),
            React.createElement("select",{value:form.pod,onChange:function(e){setF("pod",e.target.value);},style:inputStyle},
              React.createElement("option",{value:""},"No pod"),
              pods.map(function(p){return React.createElement("option",{key:p.id,value:p.name},p.name);})
            )
          )
        ),
        React.createElement("button",{onClick:createUser,style:{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"10px",cursor:"pointer",fontSize:13,fontWeight:600}},"Create User")
      )
    ),
    showReset&&React.createElement(Modal,{title:"Reset Password",onClose:function(){setShowReset(null);setNewPw("");}},
      React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:10}},
        React.createElement("div",{style:{fontSize:13,color:T.text2}},"New password for ",React.createElement("strong",null,showReset.name)),
        React.createElement("input",{type:"password",value:newPw,onChange:function(e){setNewPw(e.target.value);},placeholder:"Min 8 characters",style:inputStyle}),
        React.createElement("button",{onClick:function(){resetPassword(showReset.id);},style:{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"10px",cursor:"pointer",fontSize:13,fontWeight:600}},"Reset Password")
      )
    ),
    users.map(function(u){
      var exp=sel===u.id;
      return React.createElement(Card,{key:u.id,style:{padding:"12px 14px"}},
        React.createElement("div",{style:{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}},
          React.createElement(Av,{i:(u.name||"?").split(" ").map(function(x){return x[0];}).join("").slice(0,2),s:34,c:RC[u.role]||T.accent}),
          React.createElement("div",{style:{flex:1,minWidth:0}},
            React.createElement("div",{style:{fontSize:13,fontWeight:600,color:T.text}},u.name,
              u.locked&&React.createElement("span",{style:{fontSize:10,color:T.danger,background:T.danger+"22",borderRadius:4,padding:"1px 6px",marginLeft:8}},"LOCKED")
            ),
            React.createElement("div",{style:{fontSize:11,color:T.text3}},"@",u.username," · ",u.email||"no email"," · pod: ",u.pod||"—")
          ),
          React.createElement(Bdg,{t:u.role,c:RC[u.role]||T.accent}),
          React.createElement("div",{style:{display:"flex",gap:6,flexWrap:"wrap"}},
            React.createElement("button",{onClick:function(){setSel(exp?null:u.id);},style:{background:T.inset,color:T.text2,border:"1px solid "+T.border,borderRadius:6,padding:"4px 10px",cursor:"pointer",fontSize:11}},exp?"Close":"Edit"),
            u.locked&&React.createElement("button",{onClick:function(){unlockUser(u.id);},style:{background:T.success+"22",color:T.success,border:"1px solid "+T.success+"44",borderRadius:6,padding:"4px 10px",cursor:"pointer",fontSize:11}},"Unlock"),
            React.createElement("button",{onClick:function(){setShowReset(u);},style:{background:T.warning+"22",color:T.warning,border:"1px solid "+T.warning+"44",borderRadius:6,padding:"4px 10px",cursor:"pointer",fontSize:11}},"Reset PW"),
            u.id!==user.sub&&React.createElement("button",{onClick:function(){deleteUser(u.id,u.name);},style:{background:T.danger+"22",color:T.danger,border:"1px solid "+T.danger+"44",borderRadius:6,padding:"4px 10px",cursor:"pointer",fontSize:11}},"Delete")
          )
        ),
        exp&&React.createElement("div",{style:{marginTop:12,paddingTop:12,borderTop:"1px solid "+T.border,display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:10}},
          React.createElement("div",null,React.createElement("label",{style:labelStyle},"Role"),
            React.createElement("select",{value:u.role,onChange:function(e){updateUser(u.id,{role:e.target.value});},style:inputStyle},
              ROLES.map(function(r){return React.createElement("option",{key:r,value:r},r);})
            )
          ),
          React.createElement("div",null,React.createElement("label",{style:labelStyle},"Pod"),
            React.createElement("select",{value:u.pod||"",onChange:function(e){updateUser(u.id,{pod:e.target.value||null});},style:inputStyle},
              React.createElement("option",{value:""},"No pod"),
              pods.map(function(p){return React.createElement("option",{key:p.id,value:p.name},p.name);})
            )
          ),
          React.createElement("div",null,React.createElement("label",{style:labelStyle},"Email"),
            React.createElement("input",{type:"email",defaultValue:u.email||"",onBlur:function(e){if(e.target.value!==u.email)updateUser(u.id,{email:e.target.value});},style:inputStyle})
          ),
          React.createElement("div",null,React.createElement("label",{style:labelStyle},"Lock"),
            React.createElement("div",{style:{display:"flex",alignItems:"center",gap:8,marginTop:6}},
              React.createElement("input",{type:"checkbox",checked:!!u.locked,onChange:function(e){updateUser(u.id,{locked:e.target.checked});},style:{width:16,height:16}}),
              React.createElement("span",{style:{fontSize:12,color:T.text2}},"Locked")
            )
          )
        )
      );
    })
  );
}

